import { Navigate } from 'react-router-dom';

const SettingsIndex = () => <Navigate to='/settings/account/profile' />;

export { SettingsIndex };
